// Which energy, if any, the Phase Stability panel may place on the Materials
// Project convex hull for a candidate (#57, 2026-11-04 silent-failure audit).
//
// The hull is built from Materials Project FORMATION energies (about -1 to
// -3 eV/atom). The panel used to fall back to a GPAW single-point's
// energy_per_atom, which is a TOTAL energy (about -6 eV/atom for LiFePO4): on
// that hull it lands far below every phase, so any candidate that only had
// real DFT was labelled "stable" with a large negative energy above hull.
// A total energy can never stand in for a formation energy, so the only
// accepted source is the CHGNet surrogate's formation energy; otherwise send
// nothing and let the service use an exact Materials Project match or report
// the stability as unknown.

export function phaseStabilityEnergy(analysisCache, idx) {
  const surrogate = analysisCache?.[`${idx}::dft_surrogate`];
  const fe = surrogate && surrogate.ok !== false ? surrogate.formation_energy_per_atom : null;
  if (typeof fe === 'number' && Number.isFinite(fe)) {
    return { formation_energy_per_atom: fe, energy_source: 'chgnet' };
  }
  return { formation_energy_per_atom: null, energy_source: null };
}

// Human label for the panel's "Energy Source" card.
export function phaseStabilitySourceLabel(source) {
  if (source === 'chgnet') return 'CHGNet estimate (approximate)';
  if (source === 'mp_match') return 'Materials Project match';
  if (source === 'provided') return 'Provided by caller';
  return 'Not available';
}
